import WhRuntimeException from "./WhRuntimeException";
import WhEmptyArgumentException from "./WhEmptyArgumentException";
import WhArgumentLengthExceedException from "./WhArgumentLengthExceedException";
import WhArgumentLte0Exception from "./WhArgumentLte0Exception";
import WhArgumentLt0Exception from "./WhArgumentLt0Exception";
import WhIllegalDateTimeException from "./WhIllegalDateTimeException";

class WhParameter {
  /**
   * 判断是否为无效(空、null、undifined、全空格)
   *
   * @param param
   * @returns {Boolean}
   */
  static isInvalid(param) {
    if (false === param) {
      return false;
    }

    if (!param && 0 === param) {
      return false;
    }

    return !param || 0 === (param + "").trim().length;
  }

  /**
   * 判断是否为数字
   *
   * @param param
   * @returns {Boolean}
   */
  static isNum(param) {
    return this.isInvalid(param) ? false : !isNaN(param);
  }

  /**
   * 校验入参非空
   * @param param
   * @param paramName
   */
  static verifyNotEmpty(param, paramName) {
    if (this.isInvalid(paramName)) {
      throw new WhRuntimeException();
    }

    if (this.isInvalid(param)) {
      throw new WhEmptyArgumentException(paramName + "不能为空");
    }
  }

  /**
   * 校验入参长度校验
   * @param param
   * @param paramName
   * @param maxLen
   */
  static verifyStrMaxLen(param, paramName, maxLen) {
    this.verifyNotEmpty(param, paramName);

    if (!maxLen || maxLen <= 0) {
      throw new WhRuntimeException();
    }

    if (param.length > maxLen) {
      throw new WhArgumentLengthExceedException(paramName + "长度不能超过" + maxLen + "位");
    }
  }

  /**
   * 校验入参长度校验
   * @param param
   * @param paramName
   * @param maxLen
   */
  static verifyEmptyAbleMaxLen(param, paramName, maxLen) {
    // 检验是否无效参数
    if (this.isInvalid(param)) {
      // 为空，允许
      if (null !== param && param.trim().length === 0) {
        return;
      }

      throw new WhRuntimeException();
    }

    // 最大长度是否合法
    if (!maxLen || maxLen <= 0) {
      throw new WhRuntimeException();
    }

    // 是否超过最大长度
    if (param.length > maxLen) {
      throw new WhArgumentLengthExceedException(paramName + "长度不能超过" + maxLen + "位");
    }
  }

  /**
   * 校验入参大于0
   * @param param
   * @param paramName
   */


  static verifyGt0(param, paramName) {
    this.verifyNotEmpty(param, paramName);

    // 是否为数字
    if (!this.isNum(param)) {
      throw new WhRuntimeException();
    }

    if (param <= 0) {
      throw new WhArgumentLte0Exception(paramName + "必须大于零");
    }
  }

  /**
   * 校验入参大于等于0
   * @param param
   * @param paramName
   */
  static verifyGte0(param, paramName) {
    this.verifyNotEmpty(param, paramName);

    // 是否为数字
    if (!this.isNum(param)) {
      throw new WhRuntimeException();
    }

    if (param < 0) {
      throw new WhArgumentLt0Exception(paramName + "必须大于或等于零");
    }
  }

  /**
   * 比较开始与截止日期或日期时间
   *
   */
  static verifyStartEndDate(startDate, startTxt, endDate, endTxt) {
    let start = new Date(startDate.replace("-", "/").replace("-", "/"));
    let end = new Date(endDate.replace("-", "/").replace("-", "/"));
    console.log(start);
    console.log(end);
    if (end < start) {
      throw new WhIllegalDateTimeException(startTxt + "不能超过" + endTxt);
    }
  }


  static retainNonNegative(param) {
    return param.replace(/[^\d.]/g, "")
      .replace(/^[0]{2,}/g, "0")
      .replace(/^(\d+)\.(\d{0,2}).*$/, '$1.$2');
  }
}

export default WhParameter


// WEBPACK FOOTER //
// ./src/assets/csui/parameter/WhParameter.js